<template>
  <div :class="{
    'booking-hotel': true,
    'booking-hotel--small': !toggled }">
    <div class="booking-hotel__container">
      <div class="booking-hotel__picture">
        <img :src="`${hotel.ImageUrl}?h=210`" alt="Hotel">
      </div>
      <div class="booking-hotel__summary">
        <button @click="toogle" :class="{
          'booking-hotel__button': toggled,
          'booking-hotel__button--rotated': !toggled,
        }">
          <span v-if="toggled">SZCZEGÓŁY</span>
          <span v-if="!toggled" class="booking-hotel__button--price"> {{ formattedTotalPrice }} </span>
          <div v-if="!toggled" class="booking-hotel__button--currency">
            <Icon v-if="isTablet" icon="couple" />
            <span>{{ currency }}</span>
          </div>
          <Icon icon="v" :class="{
            'icon__arrow' : toggled,
            'icon__arrow--rotated' : !toggled,
          }"/>
        </button>
        <div v-if="!toggled" class="booking-hotel__hotel-name">{{ hotel.HotelName }}</div>
        <div v-else class="booking-hotel__wrapper">
          <div>
            <h2 class="booking-hotel__title">{{ header }}</h2>
            <p class="booking-hotel__offer-type">Hotel / {{ hotel.BoardStandard }}</p>
            <div class="booking-hotel__hotel-name">
              <p>
                {{ hotel.HotelName }}
                <span :class="[ 'stars', 'stars--white', hotel.HotelStandardStarsCss ]" />
                <v-popover trigger="hover" :autoHide="false">
                  <Icon icon="info" class="icon__info"/>
                  <template slot="popover">
                    <div v-html="hotel.InfoTooltipText" />
                    <a href="https://www.grecos.pl/rezerwacja-kroki">Czytaj więcej</a>
                  </template>
                </v-popover>
              </p>
            </div>
            <p class="booking-hotel__location">{{ hotel.LocationSlug }}</p>
          </div>
          <div class="booking-hotel__local-category" v-if="hotel.HotelLocalStandardStarsCss || hotel.HotelKeysValue">
            <span>KATEGORIA LOKALNA:</span>
            <span v-if="hotel.HotelLocalStandardStarsCss" :class="[ 'stars', 'stars--white', hotel.HotelLocalStandardStarsCss ]" />
            <span v-else :class="[ 'keys', hotel.HotelKeysValue ]" />
          </div>
          <div class="booking-hotel__travel-time">
            <Icon icon="calendar" class="icon__calendar"/>
            <p>{{ departureDate }} - {{ returnDate }} / <span>{{ days }} <b>/ {{ nights }}</b></span></p>
          </div>
        </div>
      </div>
    </div>

    <BookingSidebar v-if="offerExist && !isFluidDesktop && toggled" :data="offer" />    
   </div>
</template>

<script>
import moment from 'moment'
import Tooltip from 'v-tooltip'
import Vue from 'vue'
import Component from 'vue-class-component'
import '@/stylesheets/modules/tooltip.scss'
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

import BookingSidebar from '@/components/booking/Sidebar'
import Icon from '@/components/Icon'
import Store from '@/store/index'
import { SET_HOTEL } from '@/store/mutation-types'
import MediaDetector from '@/utils/MediaDetector'
import { addSpace } from '@/utils/priceFormat'

Vue.use(Tooltip)

@Component({
  store: Store,
  mixins: [
    MediaDetector,
  ],
  components: {
    Icon,
    BookingSidebar,
  },
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    header: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  methods: {
    ...mapActions({
      setHotel: `Booking/${SET_HOTEL}`,
    }),
  },
  computed: {
    ...mapGetters({
      offerTotalPrice: 'Booking/getOfferTotalPrice',
      offer: 'Booking/getOffer',
    }),
    formattedTotalPrice () {
      return addSpace(this.offerTotalPrice)
    },
  },
})
export default class ReservationHotelSummary extends Vue {
  currency = 'zł'
  toggled = true

  get departureDate () {
    return moment(this.hotel.DepartureDate).format('dd DD.MM.YYYY')
  }

  get returnDate () {
    return moment(this.hotel.ReturnDate).format('dd DD.MM.YYYY')
  }

  get days () {
    if (this.hotel.Duration > 1) {
      return `${this.hotel.Duration} dni`
    }

    return `${this.hotel.Duration} dzień`
  }
  get nights () {
    if (this.hotel.NumberOfNights > 4) {
      return `${this.hotel.NumberOfNights} nocy`
    }
    if (this.hotel.NumberOfNights > 1) {
      return `${this.hotel.NumberOfNights} noce`
    }

    return `${this.hotel.NumberOfNights} noc`
  }

  get offerExist () {
    return Object.keys(this.offer).length !== 0
  }

  toogle () {
    this.toggled = !this.toggled
  }

  mounted () {
    this.setHotel(this.hotel)
  }
}
</script>

<style lang="scss" scoped>
.booking-hotel {
  margin: 0;
  padding: 0;
  z-index: 1;

  &__container {
    min-height: 40px;
    background-color: #005CA9;
    color: #ffffff;
    
    @include mediaFluid(tablet) {
      display: grid;
      grid-template-columns: 295px 1fr;
      min-height: 70px;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;

    @include mediaFluid(tablet) {
      padding-bottom: 5px;
    }
  }

  &__picture {
    display: none;
    position: relative;
    height: 210px;
    overflow: hidden;

    @include mediaFluid(tablet) {
      display: flex;
    }

    img {
      position: absolute;
      height: 100%;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__button {
    position: absolute;
    display: flex;
    right: 20px;
    top: 22px;
    padding: 0;
    background: none;
    border: none;
    color: #fff;

    @include mediaFluid(tablet) {
      top: 17px;
    }

    @include mediaFluid(desktop) {
      display: none;
    }

    &--rotated {
      position: absolute;
      right: 20px;
      top: 5px;
      background: none;
      border: none;
      padding: 0;
      display: flex;
      align-items: center;
    }

    &--price {
      font-size: 26px;
      font-weight: bold;
      margin-right: 4px;
    }

    &--currency {
      font-size: 16px;
      font-weight: bold;
      margin-right: 8px;
      align-items: flex-end;
      text-transform: uppercase;

      @include mediaFluid(tablet) {
        display: flex;
        flex-direction: column;
      }
    }

    .icon__arrow {
      font-size: 0.6em;
      margin: 0;
      padding-bottom: 1px;

      &--rotated {
        transform: rotate(180deg);
        font-size: 0.8em;
        margin: 0;
        padding-top: 5px;
      }
    }

    span {
      font-family: 'Gotham';
      font-size: 11px;
      line-height: 14px;
      text-align: right;
      margin-right: 5px;
    }
  }

  &__summary {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 20px;

    @include mediaFluid(tablet) {
      padding: 15px;
    }
    @include mediaFluid(desktop) {
      padding: 16px 21px;
    }
  }

  &__hotel-name {
    margin: 5px 0 0;
    display: flex;
    align-items: end;
    text-transform: uppercase;

    @include mediaFluid(tablet) {
      flex-direction: column;
      align-items: flex-start;
    }

    @include mediaFluid(desktop) {
      margin-bottom: 3px;
      flex-direction: row;
    }
    
    p {
      color: #FEFFFF;
      font-family: Gotham;
      font-size: 26px;
      font-weight: bold;
      line-height: 26px;
      margin: 0;
      text-transform: uppercase;
      margin-right: 7px;

      @include mediaFluid(tablet) {
        letter-spacing: -0.5px;
      }

      @include mediaFluid(desktop) {
        flex-basis: auto;
        margin-right: 17px;
      }
    }

    .stars {
      margin-bottom: 2px;
      display: inline-block;
      margin-left: 6px;

      &::after {
        font-size: .6em;
        right: -12px;
        top: -6px;
      }
    }

    &.closed p {
      margin: 8px 0 0 0;
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
      width: 90px;
    }
  }

  &__title {
    margin: 0;
    font-family: 'Georgia';
    font-size: 1.9em;
    font-style: italic;
    font-weight: normal;
    line-height: .8em;
    letter-spacing: 1px;

    @include mediaFluid(tablet) {
      line-height: normal;
    }

    @include mediaFluid(desktop) {
      line-height: 1;
    }
  }

  &__offer-type {
    font-family: 'Gotham';
    font-size: 12px;
    line-height: normal;
    margin: 21px 0 0;
    text-transform: uppercase;

    @include mediaFluid(tablet) {
      margin-top: 17px;
      letter-spacing: .2px;
    }

    @include mediaFluid(desktop) {
      margin-top: 20px;
    }
  }

  &__location {
    margin: 7px 0 0;
    display: flex;
    align-items: flex-end;
    font-size: .85em;
    text-transform: uppercase;

    @include mediaFluid(tablet) {
      margin-top: 0;
    }

    .icon__calendar {
      font-size: 1.3em;
      margin-right: 10px;
    }

    p {
      font-family: 'Gotham';
      font-size: 14px;
      font-weight: bold;
      line-height: normal;
      margin: 0;

      @include mediaFluid(tablet) {
        font-size: 16px;
      }
    }
  }

  &__travel-time {
    display: flex;
    margin: 19px 0 0;
    align-items: center;

    @include mediaFluid(tablet) {
      margin-top: 0;
    }

    .icon__calendar {
      font-size: 1.35em;
    }

    p {
      margin-left: 9px;
      margin-top: 3px;
      font-weight: bold;

      @include mediaFluid(tablet) {
        font-size: 1.15em;
      }

      span {
        font-family: 'Gotham Book';
        font-weight: normal;
      }
    }
  }

  &__local-category {
    .stars {
      display: inline-block;
      vertical-align: middle;
    }
  }

  .booking-sidebar {
    display: block;

    @include mediaFluid(tablet) {
      margin-top: 20px;
    }
  }

  .icon__info {
    font-size: 22px;
  }

  .v-popover {
    display: inline-block;
    margin-left: 10px;
  }
}

.keys {
  display: inline-block;
  background-size: cover;
  height: 11px;
  position: relative;
  margin-right: 1px;
  background: url("/assets/images/icons/key_transparent.png");
}

.one-key {
  width: 11px;
}

.two-keys {
  width: 22px;
}

.three-keys {
  width: 33px;
}

.four-keys {
  width: 44px;
}

.five-keys {
  width: 55px;
}

// styles for toggled section
.booking-hotel {
  &--small &__container {
    grid-template-columns: 1fr;
  }

  &--small &__summary {
    padding: 0 20px;
    flex-direction: row-reverse;
    align-items: center;
  }

  &--small &__picture {
    display: none;
  }

  &--small &__button--rotated {
    position: initial;
    color: #fff;
    padding-top: 7px;
    align-items: flex-end;

    @include mediaFluid(tablet) {
      padding-top: 6px;
    }
  }

  &--small &__button--price {
    line-height: 1;

    @include mediaFluid(tablet) {
      font-size: 3.1em;
      line-height: .8;
      margin-right: 3px;
    }
  }

  &--small &__button--currency {
    @include mediaFluid(tablet) {
      margin: 0 43px 1px 2px;
    }
  }

  &--small &__hotel-name {
    margin: 10px 0 0;
    font-size: .9em;
    line-height: 1.1em;
    flex: 1 0;

    @include mediaFluid(tablet) {
      font-size: 1.35em;
      margin-top: 2px;
    }
  }
  
  &--small .icon__arrow--rotated {
    margin-bottom: 5px;
    transform: rotate(180deg);
    font-size: .9em;

    @include mediaFluid(tablet) {
      margin-bottom: 13px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/booking/HotelSummary.vue